// extracted by mini-css-extract-plugin
module.exports = {"controllerArea":"index__3Bbd9","controllerMenus":"index__2hm5l","menus":"index__2Kl67","icons":"index__y-nD5"};